import React, { useState, useRef } from 'react';

var styles = {"popover_wrapper":"sNWq1"};

const PopoverWrapper = ({ children }) => {
  const [active, setActive] = useState(false);
  const showTooltip = () => setActive(true);
  const hideTooltip = () => setActive(false);
  const popoverParentRef = useRef(null);
  const parent = popoverParentRef == null ? void 0 : popoverParentRef.current;
  return /* @__PURE__ */ React.createElement("div", { className: styles.popover_wrapper, ref: popoverParentRef }, children({ active, showTooltip, hideTooltip, parent }));
};

export { PopoverWrapper as default };

import 'wix-rich-content-common/dist/lib/styles.PopoverWrapper.min.global.css'